import { useState, useEffect } from "react";
import "./Verification.css";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import axios from "../../axios.jsx";
import { useLocation } from "react-router-dom";
import Cookies from "js-cookie";
axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";

export default function PaymentDetails() {
  const [details, setDetails] = useState(null);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [reason, setReason] = useState("");
  const loc = useLocation();
  const scholar = loc.state.mobile;
  setInterval(() => {
    if (!Cookies.get("userInfo")) {
      logout();
    }
  }, 1000);
  useEffect(() => {
    if (Cookies.get("username") != "PaymentOfficer") {
      alert("unauthorized to this page")
      logout();
    }
    const data = {
      mobile: scholar,
    };
    axios
      .post("/api/get-payment-details", data)
      .then((resData) => {
        setDetails(resData.data.data);
        console.log(details);
      })
      .catch((e) => {
        alert("can't find scholar");
      });
  }, []);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleApprove = () => {
    setLoading(true);
    const req = {
      mobile: scholar,
      status: "payment"
    }
    axios
      .put("api/update-verification-status", req)
      .then((resData => {
        alert("Approved Successfully");
        window.location.href = "/pending-payment-list"
      }))
      .catch((e) => {
        alert("server error try again")
        console.log(e);
      })
    setLoading(false);
  }
  const handleReject = () => {
    setLoading(true);
    const req = {
      mobile: scholar,
      status: "REJECTED",
      reason
    }
    axios
      .put("update-verification-status", req)
      .then((resData => {
        alert("Rejected Successfully");
        window.location.href = "/pending-payment-list"
      }))
      .catch((e) => {
        alert("server error try again")
        console.log(e);
      })
    setLoading(false);
  }
  return (
    <>
      <br />
      <br />
      <form className="Auth-form">
        <div className="Auth-form-content">
          <h3 className="Auth-form-title">Verify Payment Details</h3>
          {details === null ? (
            <center>
              <RotateLeftIcon
                sx={{
                  fontSize: "3rem",
                  margin: "0 auto",
                  color: "rgba(0,0,0,0.6)",
                  animation: "spin 1s linear infinite",
                  "@keyframes spin": {
                    "0%": {
                      transform: "rotate(360deg)",
                    },
                    "100%": {
                      transform: "rotate(0deg)",
                    },
                  },
                }}
              />{" "}
              Loading Details
            </center>
          ) : (
            <div className="form-group mt-3">
              <table>
                <tr>
                  <td>
                    <label>Scholar Mobile</label>
                  </td>
                  <td>
                    <input
                      value={details.mobile}
                      className="form-control"
                      readOnly
                      type="text"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Transaction Id</label>
                  </td>
                  <td>
                    <input
                      value={details.transaction_id}
                      className="form-control"
                      readOnly
                      type="text"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Transaction Amount</label>
                  </td>
                  <td>
                    <input
                      value={details.transaction_amount}
                      className="form-control"
                      readOnly
                      type="text"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Date of Payment</label>
                  </td>
                  <td>
                    <input
                      value={details.date_of_payment}
                      className="form-control"
                      readOnly
                      type="date"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Proof of Payment</label>
                  </td>
                  <td>
                    <a href={axios.defaults.baseURL + "api" + details.proof_of_payment} target="_blank">
                      <button type="button" className="btn btn-secondary">
                        View File
                      </button>
                    </a>
                  </td>
                </tr>
              </table>
              <div className="d-grid gap-2 mt-3">
                <button
                  type="button"
                  className="btn btn-secondary approve-btn"
                  onClick={handleApprove}
                  disabled={loading}
                >
                  Approve
                </button>
                <button
                  type="button"
                  className="btn btn-secondary reject-btn"
                  onClick={handleClickOpen}
                  disabled={loading}
                >
                  Reject
                </button>
              </div>
            </div>
          )}
        </div>
      </form>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Resaon For Rejection</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Reason"
            type="text"
            fullWidth
            variant="standard"
            required
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleReject}>Reject</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

function logout() {
  window.localStorage.clear();
  Cookies.remove("userInfo");
  Cookies.remove("username");
  window.location.href = "/pvtOfficer-login";
}